export const extendContainer = {
    container: () => ({
        tabletLarge: {
            paddingTop: 0,
        },
    }),
};

export const extendTitle = {
    maxWidth: '65.43rem',
};
